import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  ACTOR_TYPES,
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../../helpers';
import { apiCall } from '../../../services';

const ENDPOINT = `${APIConfiguration.authorization}roles/configurable/${COMMON_QUERY_PARAMS.ENTITY_TYPE}`;

export interface RolesForSellerSummaryDto {
  roles: {
    id: string;
    name: string;
    description: string;
  }[];
  sellerName: string;
  sellerId: string;
}

export interface GetConfigurableRolesQueryPayload {
  entityId?: string;
  entityType?: string;
}

export const getConfigurableRolesQuery = async ({
  entityId,
  entityType = ACTOR_TYPES.SELLER,
}: GetConfigurableRolesQueryPayload): Promise<
  BackResponse<RolesForSellerSummaryDto[]> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.ENTITY_TYPE, entityType);

    const response = await apiCall<BackResponse<RolesForSellerSummaryDto[]>>(
      buildUrl(url, { entityId }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
